import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import './styles/style.css'
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import CustomPatchesPricing from "./pages/CustomPatchesPricing";
import MonthlySubscription from "./pages/MonthlySubscription";
import Portfolio from "./pages/Portfolio";
import Blogs from "./pages/Blogs";
import PaymentDetails from "./pages/PaymentDetails";
import CompletePayment from "./pages/CompletePayment";
import TermConditions from "./pages/TermConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LoginSignup from "./pages/LoginSignup"; 
import UserDashboard from "./pages/UserDashboard";
import PaymentThankYou from "./pages/PaymentThankYou";
import Careers from "./pages/Careers";
import BlogDetail from "./pages/BlogDetail";
import PrintOnDemand from "./pages/PrintOnDemand";
import Sewout from "./pages/Sewout";

import EmbroideryDigitizing from "./pages/services/EmbroideryDigitizing";
import Vectorization from "./pages/services/Vectorization";
import WebsiteDevelopment from "./pages/services/WebsiteDevelopment";
import LogoDesigning from "./pages/services/LogoDesigning";
import Brandings from "./pages/services/Brandings";

import CustomEmbroideryDigitizing from "./pages/services/CustomEmbroideryDigitizing";
import LogoDigitizingForEmbroidery from "./pages/services/LogoDigitizingForEmbriodery";
import CapHatDigitizing from "./pages/services/CapHatDigitizing";
import PuffEmbroideryDigitizing from "./pages/services/PuffEmbroideryDigitizing";
import FlatEmbroideryDigitizing from "./pages/services/FlatEmbroideryDigitizing";
import LeftChestLogoDigitizing from "./pages/services/LeftChestLogoDigitizing";
import JacketBackDigitizing from "./pages/services/JacketBackDigitizing";
import SleeveLogoDigitizing from "./pages/services/SleeveLogoDigitizing";
import AppliqueDigitizing from "./pages/services/AppliqueDigitizing";
import ChenilleEmbroideryDigitizing from "./pages/services/ChenilleEmbroideryDigitizing";
import PatchDigitizing from "./pages/services/PatchDigitizing";
import BadgeDigitizing from "./pages/services/BadgeDigitizing";
import MonogramDigitizing from "./pages/services/MonogramDigitizing";
import TowelDigitizing from "./pages/services/TowelDigitizing";

import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Remove StrictMode temporarily - it causes double mounting
  <Router>
    <ScrollToTop /> 
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/custom-patches-pricing" element={<CustomPatchesPricing />} />
      <Route path="/monthly-subscription" element={<MonthlySubscription />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogs/:slug" element={<BlogDetail />} />
      <Route path="/terms-conditions" element={<TermConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/payment-details" element={<PaymentDetails />} />
      <Route path="/complete-payment/:token" element={<CompletePayment />} />
      <Route path="/login-signup" element={<LoginSignup />} />
      <Route path="/user-dashboard" element={<UserDashboard />} />
      <Route path="/payment-thankyou" element={<PaymentThankYou />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/print-on-demand" element={<PrintOnDemand />} />
      <Route path="/sewout" element={<Sewout />} />

      <Route path="/services/embroidery-digitizing-services" element={<EmbroideryDigitizing />} />
      <Route path="/services/vectorization-services" element={<Vectorization />} />
      <Route path="/services/website-design-development-services" element={<WebsiteDevelopment />} />
      <Route path="/services/logo-design-services" element={<LogoDesigning />} />
      <Route path="/services/branding-design-services" element={<Brandings />} />

      <Route path="/services/custom-embroidery-digitizing-services" element={<CustomEmbroideryDigitizing />} />
      <Route path="/services/logo-digitizing-for-embroidery-services" element={<LogoDigitizingForEmbroidery />} />
      <Route path="/services/cap-hat-digitizing-services" element={<CapHatDigitizing />} />
      <Route path="/services/3d-puff-embroidery-digitizing-services" element={<PuffEmbroideryDigitizing />} />
      <Route path="/services/flat-embroidery-digitizing-services" element={<FlatEmbroideryDigitizing />} />
      <Route path="/services/left-chest-logo-digitizing-services" element={<LeftChestLogoDigitizing />} />
      <Route path="/services/jacket-back-digitizing-services" element={<JacketBackDigitizing />} />
      <Route path="/services/sleeve-logo-digitizing-services" element={<SleeveLogoDigitizing />} />
      <Route path="/services/applique-digitizing-services" element={<AppliqueDigitizing />} />
      <Route path="/services/chenille-embroidery-digitizing-services" element={<ChenilleEmbroideryDigitizing />} />
      <Route path="/services/patch-digitizing-services" element={<PatchDigitizing />} />
      <Route path="/services/badge-digitizing-services" element={<BadgeDigitizing />} />
      <Route path="/services/monogram-digitizing-services" element={<MonogramDigitizing />} />
      <Route path="/services/towel-digitizing-services" element={<TowelDigitizing />} />

    </Routes>
  </Router>
);
reportWebVitals();